import { Injectable } from '@angular/core';

import { ApiService } from './api.service';

@Injectable()
export class ConfigService {

  redirects: any;

  constructor(private apiService: ApiService) { }

  getConfig(id) {
    return this.apiService.get('/Configuration', {id: id});
  }

}
